import { Component, Input } from '@angular/core';
import { IDevice } from '../../interfaces';

@Component({
  selector: 'app-device-preview',
  templateUrl: './device-preview.component.html',
  styleUrls: ['./device-preview.component.scss'],
})
export class DevicePreviewComponent {
  @Input() device: IDevice | null = null;
  @Input() lastUpdate: string | undefined = undefined;
}
